import { FormControl, InputLabel, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

const Configurations = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [approvalConfigs, setApprovalConfigs] = useState([]);

  const getApprovalConfigs = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/pettycashapprovalconfigs?limit=100`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setApprovalConfigs(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching cash approval config:", error);
    }
  };

  useEffect(() => {
    getApprovalConfigs();
  }, []);

  return (
    <div className="h-screen p-6">
      <h1 className="font-bold md:text-2xl text-gray-800">
        Petty Cash Details
      </h1>
      <div className="flex gap-4 mt-8">
        <TextField
          type="text"
          fullWidth
          autoComplete="off"
          label="Minimum Approval Amount *"
        />
        <FormControl fullWidth>
          <InputLabel id="drop-label">Approval Users *</InputLabel>
          <Select></Select>
        </FormControl>
      </div>

      <div className="mt-8 overflow-y-auto h-[calc(100vh-200px)] space-y-4 px-4">
        {approvalConfigs.map((config, index) => (
          <div
            key={index}
            className="p-5 bg-white rounded-xl shadow-sm border border-gray-200"
          >
            <div className="text-lg font-semibold text-gray-700 mb-2">
              Min Approval Amount:
              <span className="ml-2 text-blue-600 font-bold">
                ₹{config.amount}
              </span>
            </div>

            <div className="text-sm text-gray-600 font-medium mb-1">
              Approval Users:
            </div>
            {/* <div className="flex flex-wrap gap-2">
              {config.approvalIds && config.approvalIds.length > 0 ? (
                config.approvalIds.map((user, idx) => (
                  <span
                    key={idx}
                    className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-800"
                  >
                    {user}
                  </span>
                ))
              ) : (
                <span className="text-gray-400 italic">No users assigned</span>
              )}
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Configurations;
